import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ProveedorDonacion } from './contextos/Donacion';
import { ProveedorDispositivo } from './contextos/Dispositivo';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ProveedorDonacion>
      <ProveedorDispositivo>
        <App />
      </ProveedorDispositivo>
    </ProveedorDonacion>
  </React.StrictMode>
);


